import { useMaintenanceMode } from 'hooks/queries/useMaintenanceMode'
import { MAINTENANCE_PATH } from 'paths'
import { Redirect } from 'react-router-dom'
import { MaintenanceModeProps } from './Types'

const MaintenanceModeWrapper = ({ children }: MaintenanceModeProps) => {
  const { data: inMaintenanceMode, isLoading } = useMaintenanceMode()

  if (isLoading) {
    return null
  }

  if (inMaintenanceMode) {
    return <Redirect to={MAINTENANCE_PATH} />
  }

  return <>{children}</>
}

export { MaintenanceModeWrapper }
